import * as React from 'react';
import type { SVGProps } from 'react';

const ComponentSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M4.70711 12.7072L8 16.0001L11.2929 12.7072L8 9.41434L4.70711 12.7072Z" fill="#616061"/>
    <path d="M3.29289 11.293L6.58579 8.00012L3.29289 4.70723L0 8.00012L3.29289 11.293Z" fill="#616061"/>
    <path d="M4.70711 3.29302L8 0.00012207L11.2929 3.29302L8 6.58591L4.70711 3.29302Z" fill="#616061"/>
    <path d="M12.7071 4.70723L9.41421 8.00012L12.7071 11.293L16 8.00012L12.7071 4.70723Z" fill="#616061"/>
  </svg>
);

export default ComponentSvg;